import { updateLinksAttributes } from '../../utils/handleAttributes';
import { getWindowSize } from '../../utils/helpers.js';

export default function seoBlock() {
  const widgetName = 'seoBlock';
  const widgetOpts = seoBlockOpts;
  const $widget = $(`#${widgetName}`);
  const isDesktop = getWindowSize(1170);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    textOverImage: false,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomSeo($widget, data.items);
        addAosAnimation($widget, isDesktop);
      } else {
        $widget.remove();
      }
    },
  });
}

function createCustomSeo($widget, widgetData) {
  const $seo = $widget.find('.card-widget-item');
  const { Title, Description, URL } = widgetData[0];

  $seo.replaceWith(`
      <h1 class="seo-title">${Title}</h1>
      <div class="seo-description">${Description}</div>
      ${URL == null ? '' : `<a href="${URL}" class="button" ${updateLinksAttributes(URL, Title)}>Learn More</a>`}

    `);
}

function addAosAnimation($widget, isDesktop) {
  $widget.attr({
    'data-aos': isDesktop ? 'fade-right' : 'fade-in',
    'data-aos-delay': 500,
    'data-aos-easing': 'ease-in-out',
    'data-aos-duration': '1000',
    'data-aos-once': 'true',
    'data-aos-offset': 200,
  });
}
